// ── RateForm ──
// One index rate in dbo.Rates.
//
// Stored as a DECIMAL (0.0725 = 7.25%) — that is what the statements, the
// prepopulate procedure and scheduled payments add to the margin. The field is
// labelled and entered in PERCENT, and converted here, so typing 7.25 can't
// silently store 725%. (Same treatment as the percent fields on TermsForm.)
//
// Index is a pick list, not free text: index_name must match a term's Rate
// Index exactly or the rate is simply never found.
import { useState } from "react";
import { Btn, FInput, FSelect, Field, Modal, ReadOnlyForm } from "../../../shared/ui";
import { useFreshForm } from "../../../shared/hooks";
import { useApp } from "../../../shared/appContext";

const INDEXES = ["SOFR", "PRIME", "BSBY1M"];
const SOURCES = ["Wall Street Journal", "NY Fed Reserve", "Bloomberg"];
const toPctText = v =>
  (v === null || v === undefined || v === "") ? "" : String(+(Number(v) * 100).toFixed(6));

export const RateForm = ({ initial, readOnly }) => {
  const { role, modal, setModal, closeModal, saving, error, saveRec } = useApp();
  const [f, set] = useFreshForm(initial || { date:"", source:"", index_name:"", rate:"" }, "Rates");
  // Typed text held locally so "7." isn't rewritten mid-keystroke.
  const [pct, setPct] = useState(() => toPctText((initial || {}).rate));
  const onPct = t => { setPct(t); set("rate")(t === "" ? null : Number(t) / 100); };
  const indexOptions = ["", ...INDEXES, ...(f.index_name && !INDEXES.includes(f.index_name) ? [f.index_name] : [])];
  // A saved source not in the list (older free-text entries) still shows, so a save never blanks it.
  const sourceOptions = ["", ...SOURCES, ...(f.source && !SOURCES.includes(f.source) ? [f.source] : [])];

  return <Modal title={readOnly ? "View Rate" : initial ? "Edit Rate" : "Add Rate"} onClose={closeModal}
    onEdit={readOnly && role.canEdit ? () => setModal({ type:"rate-edit", rec:initial, onDone:modal.onDone }) : null}>
    <ReadOnlyForm readOnly={readOnly}>
      <Field label="Date"><FInput value={f.date?.slice(0,10) || ""} onChange={set("date")} type="date" /></Field>
      <Field label="Index"><FSelect value={f.index_name || ""} onChange={set("index_name")} options={indexOptions} /></Field>
      <Field label="Rate (%)"><FInput value={pct} onChange={onPct} type="number" /></Field>
      <Field label="Source"><FSelect value={f.source || ""} onChange={set("source")} options={sourceOptions} /></Field>
    </ReadOnlyForm>
    {!readOnly && error && <div style={{ color:"#993C1D", fontSize:12, marginBottom:8 }}>{error}</div>}
    <div style={{ display:"flex", gap:8, justifyContent:"flex-end", marginTop:8 }}>
      <Btn onClick={closeModal}>{readOnly ? "Close" : "Cancel"}</Btn>
      {!readOnly && <Btn disabled={saving || !f.date || !f.index_name || f.rate === null || f.rate === ""}
        onClick={() => saveRec("saveRate", f, initial ? "Edited" : "Added", "Rates", (initial ? "Updated" : "Added") + " rate", modal.onDone)}
        variant="primary">{saving ? "Saving..." : "Save"}</Btn>}
    </div>
  </Modal>;
};
